import './styles.sass'

import { ReactComponent as InfoIcon } from '@/assets/icons/info-icon-purple.svg'
import { ReactComponent as CloseIcon } from '@/assets/icons/close-icon.svg'
import modalService from '@/services/modal.service'

export function MoreInfoModal () {
  return (
    <div className='more-info-modal'>
      <div className="close-button" onClick={() => modalService.close()}>
        <CloseIcon />
      </div>
      <div className='more-info-modal-header'>
        <InfoIcon/>
        <p>Additional info</p>
      </div>
      <p>The final step varies in time depending on the domain name you have selected.</p>
      <p>It can take several minutes to several hours.</p>
      <p>On this page we list the steps this takes and we'll check off each step as we complete them.</p>
      <p>You can close this window and we'll send you an email when the process completes.</p>
      <p>Thanks for choosing Boxes!</p>
    </div>
  )
}
